import { I18n } from '@calendly/i18n';
import { DeleteIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const deleteFooterWrapperCss = "d4pqjvd";
const DeleteFooterWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(deleteFooterWrapperCss, props.className)} />;
});
export const DeleteFooter = ({
  setShowDeleteModal,
  handleTrackModal
}) => <DeleteFooterWrapper>
    <MinimalButton decoration="danger" onClick={() => {
    handleTrackModal('deleteModalOpen');
    setShowDeleteModal(true);
  }}>
      <DeleteIcon />
      <BodyText size="medium" weight="semibold">
        {I18n.t('publisher.personal_settings.meeting_recaps.delete_button_text')}
      </BodyText>
    </MinimalButton>
  </DeleteFooterWrapper>;

require("./delete_footer.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./delete_footer.js");